// react
import React, { useState } from 'react'

// css
// FIXME:
// import '../../css/components/AccountSettings.styl'

// components
import { Input, Button } from '@st-operations/uikit/src/v2/index.js'

// libraries
import User from '_lib/User'
import { useUser } from '_hooks'

// constants
const BUTTON_STYLE = {
  display: 'table',
  width: 'inherit',
  margin: 0,
}

const INITIAL_STATE = {
  name: '',
  email: '',
  phoneNumber: '',
}

// component
const AccountSettings = () => {
  const [formValues, setFormValues] = useState(INITIAL_STATE)

  const handleLoadUser = (user) => {
    setFormValues({
      name: user.name,
      phoneNumber: user.phone_number,
      email: user.email,
    })
  }
  useUser(handleLoadUser)

  const handleChange = (value, name) => {
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }))
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    const { name, phoneNumber } = formValues

    User.updateProfile(name, phoneNumber, () => {
      toast('Your profile has been updated!')
    })
  }

  return (
    <form id="account-settings" onSubmit={handleSubmit}>
      <Input
        onChange={handleChange}
        value={formValues.name}
        placeholder="Name"
        label="Name"
        name="name"
      />
      <div className="bottom-inputs">
        <Input
          disabled={true}
          value={formValues.email}
          placeholder="Email"
          label="Email"
          name="email"
        />
        <Input
          onChange={handleChange}
          value={formValues.phoneNumber}
          placeholder="Phone number"
          label="Phone number"
          name="phoneNumber"
        />
      </div>
      <div className="button-container">
        <Button style={BUTTON_STYLE}>Save</Button>
      </div>
    </form>
  )
}
// export
export default AccountSettings
